// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global styling for the buttons */
.flat-btn {
  background: none;
  border: none;
  padding: 12px; /* Size of the button */
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px; /* Icon size */
  color: #333;
  transition: color 0.3s ease, transform 0.2s ease;
  transform-origin: center; /* Safe scaling on hover */
}

/* Hover effects */
.flat-btn:hover {
  color: #007bff; /* Color change on hover */
  transform: scale(1.1); /* Slightly enlarge the icon */
}

/* Optional focus style */
.flat-btn:focus {
  outline: none; /* Remove default focus outline */
}

/* Folder buttons container */
.folder-buttons {
  display: flex;
  flex-direction: row;
  gap: 0.5rem; /* Space between buttons */
  flex-wrap: nowrap; /* Keep all buttons in a row */
}

/* Top button container: adds padding so buttons don't touch edges */
.btn-container {
  padding: 0.5rem 1rem; /* Horizontal padding */
  overflow: hidden;     /* Prevent horizontal scroll if button grows */
}

/* Optional: separate style for top buttons if needed */
.top-btn {
  padding: 10px;
  border-radius: 6px;
  background: #f5f5f5;
}
.top-btn:hover {
  transform: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/FolderButtons.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa,EAAE,uBAAuB;EACtC,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe,EAAE,cAAc;EAC/B,WAAW;EACX,gDAAgD;EAChD,wBAAwB,EAAE,0BAA0B;AACtD;;AAEA,kBAAkB;AAClB;EACE,cAAc,EAAE,0BAA0B;EAC1C,qBAAqB,EAAE,8BAA8B;AACvD;;AAEA,yBAAyB;AACzB;EACE,aAAa,EAAE,iCAAiC;AAClD;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW,EAAE,0BAA0B;EACvC,iBAAiB,EAAE,8BAA8B;AACnD;;AAEA,oEAAoE;AACpE;EACE,oBAAoB,EAAE,uBAAuB;EAC7C,gBAAgB,MAAM,8CAA8C;AACtE;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Global styling for the buttons */\n.flat-btn {\n  background: none;\n  border: none;\n  padding: 12px; /* Size of the button */\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px; /* Icon size */\n  color: #333;\n  transition: color 0.3s ease, transform 0.2s ease;\n  transform-origin: center; /* Safe scaling on hover */\n}\n\n/* Hover effects */\n.flat-btn:hover {\n  color: #007bff; /* Color change on hover */\n  transform: scale(1.1); /* Slightly enlarge the icon */\n}\n\n/* Optional focus style */\n.flat-btn:focus {\n  outline: none; /* Remove default focus outline */\n}\n\n/* Folder buttons container */\n.folder-buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 0.5rem; /* Space between buttons */\n  flex-wrap: nowrap; /* Keep all buttons in a row */\n}\n\n/* Top button container: adds padding so buttons don't touch edges */\n.btn-container {\n  padding: 0.5rem 1rem; /* Horizontal padding */\n  overflow: hidden;     /* Prevent horizontal scroll if button grows */\n}\n\n/* Optional: separate style for top buttons if needed */\n.top-btn {\n  padding: 10px;\n  border-radius: 6px;\n  background: #f5f5f5;\n}\n.top-btn:hover {\n  transform: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
